import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    // If we are not on the home page, let the default anchor link behavior work
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = 64;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      window.history.pushState(null, '', `#${sectionId}`);
      setIsOpen(false);
    }
  };
  const scrollToTop = (e: React.MouseEvent) => {
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    window.history.pushState(null, '', window.location.pathname);
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-zinc-900" aria-label="Main navigation" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4" data-id="element-109">
        <div className="flex items-center justify-between h-16" data-id="element-110">
          {/* Logo */}
          <a href="/" onClick={scrollToTop} className="text-xl font-black uppercase tracking-tight" aria-label="Mike's Pro Detail - Home" data-id="element-111">
            <span className="text-white" data-id="element-112">Mike's</span>{' '}
            <span className="text-red-600" data-id="element-113">Pro Detail</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6" data-id="element-114">
            <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-115">
              Services
            </a>
            <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-116">
              About
            </a>
            <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-117">
              Reviews
            </a>
            <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-118">
              FAQ
            </a>
            <a href="tel:8183819905" className="flex items-center gap-2 px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-119">
              <Phone className="w-4 h-4" data-id="element-120" />
              <span className="text-base tracking-tight" data-id="element-121">(818) 381-9905</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-white p-2" aria-label="Toggle menu" data-id="element-122">
            {isOpen ? <X className="w-6 h-6" data-id="element-123" /> : <Menu className="w-6 h-6" data-id="element-124" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && <div className="md:hidden py-4 border-t border-zinc-900" data-id="element-125">
            <div className="flex flex-col gap-4" data-id="element-126">
              <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-127">
                Services
              </a>
              <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-128">
                About
              </a>
              <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-129">
                Reviews
              </a>
              <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-130">
                FAQ
              </a>
              <a href="tel:8183819905" className="flex items-center justify-center gap-2 px-5 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-131">
                <Phone className="w-4 h-4" data-id="element-132" />
                <span className="text-base tracking-tight" data-id="element-133">(818) 381-9905</span>
              </a>
            </div>
          </div>}
      </div>
    </nav>;
}